/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import React from 'react'
import { EditViewLayout } from 'ui-library/dist/external/layouts'
import { DangerButton, ContainedButton, DateInput, EditContainer, EditField, EditTitleBar, SelectOption, SelectOptions, TextArea, TextButton, TextInput } from 'ui-library/dist/external/components'
import EventScheduleAction from '../../../action/event_schedule'

function EditView(props) {
  const id = props.match.params.id
  const isUpdate = id ? true : false
  const enableSubmit = true
  return (
    <EditViewLayout>
      <EditContainer
        titleBar={<EditTitleBar title={isUpdate ? `イベントや予定の更新 (ID:${props.schedule.id})` : `イベントや予定の作成`} />}
        editAreaTabs={[]}
        footerItems={[
          <TextButton key="cancel" onClick={() => EventScheduleAction.onCancelEditView()}>
            キャンセル
          </TextButton>,
          <ActionButton>{props}</ActionButton>,
          <DeleteButton>{props}</DeleteButton>
        ]}
      >
        <>
          {[
            <EditField key={`タイトル`}>
              <TextInput label="タイトル" leadingIcon={'title'} fullWidth value={props.schedule.title} onChange={e => EventScheduleAction.onEdit('title', e.target.value)} />
            </EditField>,
            <EditField key={`日付`}>
              <DateInput label="開始日" leadingIcon={'insert_invitation'} halfWidth value={props.schedule.start_date} onDateSelect={value => EventScheduleAction.onEdit('start_date', value)} />
              <DateInput label="終了日" leadingIcon={'insert_invitation'} halfWidth value={props.schedule.end_date} onDateSelect={value => EventScheduleAction.onEdit('end_date', value)} />
            </EditField>,
            <EditField key={`施設`}>
              <SelectOptions label="宿泊施設" name="hotel_id" value={props.schedule.hotel_id} halfWidth onChange={e => EventScheduleAction.onEdit('hotel_id', e.target.value)}>
                <SelectOption value=""></SelectOption>
                {props.hotel_options.map((option, index) => (
                  <SelectOption key={`hotel-${index}`} value={option.value}>
                    {option.label}
                  </SelectOption>
                ))}
              </SelectOptions>
              <SelectOptions
                label="部屋"
                name="room_id"
                value={props.schedule.room_id}
                halfWidth
                disabled={!id && props.schedule.hotel_id == ''}
                onChange={e => EventScheduleAction.onEdit('room_id', e.target.value)}
              >
                <SelectOption value=""></SelectOption>
                {props.room_options.map((option, index) => (
                  <SelectOption key={`room-${index}`} value={option.value}>
                    {option.label}
                  </SelectOption>
                ))}
              </SelectOptions>
            </EditField>,
            <EditField key="メモ">
              <TextArea label="メモ" fullWidth value={props.schedule.memo} onChange={e => EventScheduleAction.onEdit('memo', e.target.value)} />
            </EditField>
          ].reduce((acc, curr) => [acc, '', curr])}
        </>
      </EditContainer>
    </EditViewLayout>
  )
}

function ActionButton(props) {
  const { schedule } = props.children

  return schedule.id ? (
    <ContainedButton key="update" onClick={() => EventScheduleAction.onRequestUpdate(schedule)}>
      更新
    </ContainedButton>
  ) : (
    <ContainedButton key="create" onClick={() => EventScheduleAction.onRequestCreate(schedule)}>
      新規作成
    </ContainedButton>
  )
}

function DeleteButton(props) {
  const { schedule } = props.children
  return schedule.id ? (
    <DangerButton
      key="delete"
      onClick={() => {
        if (window.confirm('削除します。よろしいですか？')) {
          EventScheduleAction.onRequestDelete(schedule.id)
        }
      }}
    >
      削除
    </DangerButton>
  ) : (
    <React.Fragment></React.Fragment>
  )
}

export default EditView
